<template>
  <!-- 大屏页面layout -->
  <div class="base_container">
    <el-container class="is-vertical">
      <el-main>
        <div class="mainMonitor">
          <div id="mapView" style="height:100%;width:100%;position: relative">
            <div class="map-switch">
              <div :class="{ active: mapType === 'street' }" @click="switchMapType('street')">{{ $t('mapB') }}</div>
              <div :class="{ active: mapType === 'satellite' }" @click="switchMapType('satellite')">
                {{ $t('satellite') }}
              </div>
            </div>
            <!-- 轨迹控制器 -->
            <TrackController
              v-if="showTrackController"
              :showTrackVideo="showTrackVideo"
              :item="currentItem"
              :listTrack.sync="listTrack"
              :listTrackIndex.sync="listTrackIndex"
              :trailQuery="query"
              :trailTotal="total"
              :trailPageNum="pageNum"
              newStyle
              @closeTrackController="closeTrackController"
              @drawTrackStart="drawTrackStart"
              @openTrackVideo="openTrackVideo"
              :external="true"
            ></TrackController>
            <!-- 轨迹对应视频 -->
            <div v-show="showVideo" class="trail-video-box" :style="{ width: '450px', height: '300px' }">
              <TrailVideotape
                :videoSrc="trailVideoData"
                :videoShow.sync="showVideo"
                :videoSecond="videoSecond"
                @trailVideo="trailVideo"
                :index="0"
              ></TrailVideotape>
            </div>
            <!-- 地图弹框容器 -->
            <div
              id="popup"
              class="ol-popup"
              :class="[currentItem.specType === 0 ? 'jls-popup' : 'gk3-popup']"
              v-if="!currentItem.noBindDevice"
            >
              <i id="popup-closer" class="ol-popup-closer" @click="closePopup"></i>
              <div id="popup-content" style="margin-bottom: 15px;">
                <div
                  :class="[
                    currentItem.specType === 0
                      ? 'jlshelmet'
                      : currentItem.onlineStatus === '0'
                      ? 'helmetStatusOff'
                      : 'helmetStatus',
                  ]"
                >
                  <!-- 轨迹关键点 信息弹框 -->
                  <div v-if="trackPopupInfo.serialNumber || trackPopupInfo.userName">
                    <TrackPopup :trackPopupInfo="trackPopupInfo"></TrackPopup>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="maskbg" v-show="isPlayTrack"></div>
        </div>
      </el-main>
      <m-footer></m-footer>
    </el-container>
  </div>
</template>
<script>
// 依赖组件
import MHeader from '@/components/new-header/Index.vue'
import MFooter from '@/components/new-footer/Index.vue'
import TrackController from '@/views/monitor/index/TrackController.vue'
import TrailVideotape from '@/views/monitor/index/TrailVideotape.vue'
import IndoorMap from '@/components/indoorMap/Index.vue'
import TrackPopup from '@/views/monitor/index/TrackPopup.vue'
import NewJlsStatusPan from '@/components/new-base/NewJlsStatusPan.vue'
// 依赖工具
import Overlay from 'ol/Overlay'
import { mapGetters } from 'vuex'
import {
  initMap,
  addElectricFenceLayer,
  switchMapType,
} from '@/common/map'
import store from '@/store/index'

// 地图对象
let mapOl = null
// 头盔图层
let helmetVectorLayer = null
// 弹窗
let popup = null
// 弹窗dom
let popupContainer = null
export default {
  name: 'NewBase',
  components: {
    MHeader,
    MFooter,
    TrackController,
    TrailVideotape,
    IndoorMap,
    TrackPopup,
    NewJlsStatusPan,
  },
  provide() {
    return {
      openPiont: this.pointOpen,
    }
  },
  data() {
    return {
      reWrite: true,
      // 管控3窗口高度
      infoWindowHeight: 200,
      isStation: false,
      deviceName: '',
      onlinePersons: null,
      normalPan: true,
      show: false,
      // jls和gk3的弹窗开关做区别 解决轨迹播放时关不了弹窗的bug
      infoWindow: {
        show: false,
        gkShow: false,
        jlsShow: false,
      },
      theme: '',
      zoom: 15,
      // 巨灵神设备0，安卓端设备1，执法仪2
      specType: '',
      // 轨迹相关
      showTrackController: false,
      trailVideoData: [],
      showVideo: false,
      // 是否展示录像图标
      showTrackVideo: false,
      listTrack: [],
      listTrackIndex: 0,
      trail: [],
      // 历史记录相关
      showHistoryRecord: false,
      // jls轨迹相关
      JlsTrailVisible: false,

      // 头盔在线状态
      onlineStatus: '0',
      // 电子围栏列表展开flag
      isOpenFencePan: false,
      fenceData: {
        polylineObj: {
          isShow: false,
          editing: false,
          paths: [],
          info: '',
        },
        polygonObj: {
          isShow: false,
          editing: false,
          paths: [],
          info: '',
        },
        circleObj: {
          isShow: false,
          editing: false,
          paths: [],
          radius: 500,
          info: '',
        },
        ouList: [],
        currEditName: '',
        newFenceForm: {
          name: '',
          checkStartTime: '09:00',
          checkEndTime: '18:00',
          eventWarn: '0',
          remark: '',
        },
        treedataList: [],
      },
      icons: [],
      showIcons: false,
      videoSecond: 0,
      // 点击轨迹的lng,lat
      spotLng: {},
      mapPlayTrail: [],
      stationList: [],
      topic: '',
      // 选中的jlsH5头盔信息
      jlsHelmet: null,
      mapType: 'street',
      // 其他页面跳转至精准调度页面
      isJump: false,
      themeMap: 'normal',
      // 室内地图组件是否展示
      indoorMapVisible: false,
      // 轨迹弹窗
      trackPopupInfo: {},
      // 告警数据
      tableData: [],
      battery: '',
      wifi: '',
      pressure: '',
      envTemp: '',
      laser: '',
      gps: '',
      mobile: '',
      flash: '',
      cam: '',
      // 是否背景图改变
      bgMainContain: false,
      // 设备在线 的连接网络情况
      onlineNetwork: false,
    }
  },
  props: {
    viewPlayTrail: {
      type: Boolean,
    },
    trailData: {
      type: Array,
    },
    trailIndex: {
      type: Number,
    },
    // 当前选中的头盔设备信息
    currentItem: {
      type: Object,
    },
    query: {
      type: Object,
    },
    total: {
      type: Number,
    },
    pageNum: {
      type: Number,
    },
  },
  computed: {
    ...mapGetters(['isDefaultTheme']),
    // 主题切换标识监听
    getTheme() {
      return this.$store.state.theme
    },
    ExitjlsHelmetInfo() {
      return this.$store.state.jlsHelmetInfo
    },
    jlstrailData() {
      return store.state.jlstrailData
    },
    jlstrailIndex() {
      return store.state.jlstrailIndex
    },
    jlsPlayTrack() {
      return store.state.jlsPlayTrack
    },
    helmetStatusObj() {
      return this.$store.state.helmetStatusObj
    },
    isPlayTrack() {
      return this.$store.state.isPlayTrack
    },
  },
  watch: {
    jlsPlayTrack(newVal) {
      if (newVal) {
        this.playJlsTrail()
      }
    },
    // 监听显示轨迹播放器
    viewPlayTrail: {
      handler: function(newVal, oldVal) {
        console.log('viewPlayTrail', newVal)
        if (newVal) {
          this.playTrail()
        } else {
          this.closeTrackController()
        }
      },
      immediate: true,
    },
    $route: {
      handler: function(val, oldVal) {
        // 跳转指挥台时 初始化页面
        if (val.name === 'command') {
          this.$store.commit('currentHelmetData', '')
          this.bgMainContain = true
          this.isJump = false
        } else {
          this.bgMainContain = false

          if (this.listTrack) {
            // 轨迹打开时跳到其他页面关闭播放的轨迹
            this.closeTrackController()
          }
          clearInterval(this.pollInterval)
        }
      },
      // 深度观察监听
      deep: true,
    },
    // 切换主题监听
    getTheme(val) {
      this.theme = val
      this.reWrite = false
      this.$nextTick(() => {
        this.reWrite = true

        if (val === 'dark') {
          this.themeMap = 'midnight'
          switchMapType('satellite', mapOl)
          this.mapType = 'satellite'
        } else {
          this.themeMap = 'normal'
          switchMapType('street', mapOl)
          this.mapType = 'street'
        }
      })
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.loadMap()
    })
    // 首次加载 如果是精准调度页面 去掉背景图
    if (this.$route.name === 'command') {
      this.bgMainContain = true
    }
    window.addEventListener('beforeunload', e => this.beforeunload(e))
  },
  destroyed() {
    // 页面离开时销毁定时器
    clearInterval(this.pollInterval)
    window.removeEventListener('beforeunload', e => this.beforeunload(e))
  },
  methods: {
    beforeunload() {
      this.$store.commit('updatePlayTrail', false)
    },
    loadMap() {
      // 地图风格
      let loctheme = localStorage.theme
      if (loctheme === 'dark') {
        this.themeMap = 'midnight'
      } else {
        this.themeMap = 'normal'
      }
      mapOl = initMap('mapView')
      console.log('地图风格', mapOl)
      helmetVectorLayer = addElectricFenceLayer(mapOl) // 头盔撒点图层

      // 初始化地图弹窗
      popupContainer = document.getElementById('popup')
      popup = new Overlay({
        element: popupContainer,
        autoPan: true,
        autoPanAnimation: {
          duration: 250,
        },
      })
      mapOl.addOverlay(popup)
      // 鼠标移到图标上变成手势
      mapOl.on('pointermove', e => {
        let pixel = mapOl.getEventPixel(e.originalEvent)
        let hit = mapOl.hasFeatureAtPixel(pixel)
        mapOl.getTargetElement().style.cursor = hit ? 'pointer' : ''
      })
      mapOl.on('click', e => {
        //在点击时获取像素区域
        var pixel = mapOl.getEventPixel(e.originalEvent)
        // 事件顺序，数值越大，执行优先级越高
        let types = { helmet: 0, fence: 1, trackpoint: 2, indoormap: 3 }
        let typeIndex = -1
        let tempFeature = ''
        mapOl.forEachFeatureAtPixel(pixel, feature => {
          let type = feature.get('type')
          if (type === 'fence' && types['fence'] > typeIndex) {
            tempFeature = feature
            typeIndex = types['fence']
            // 通过id找到最新数据
          } else if (type === 'indoormap' && types['indoormap'] > typeIndex) {
            tempFeature = feature
            typeIndex = types['indoormap']
          } else if (type === 'trackpoint' && types['trackpoint'] > typeIndex) {
            tempFeature = feature
            typeIndex = types['trackpoint']
          } else {
            // 获取点的信息
            let helmet = feature.get('helmet')
            // 打开地图泡泡
            if (helmet && types['helmet'] > typeIndex) {
              tempFeature = feature
              typeIndex = types['helmet']
            }
          }
        })
        let data
        switch (typeIndex) {
          case 0:
            this.isOpen = true
            this.pointOpen(tempFeature.get('helmet'))
            break
          case 1:
            // 通过id找到最新数据
            data = this.fenceData.treedataList.find(o => o.id === tempFeature.getId())
            if (data) {
              this.openFenceInfo(data)
            }
            break
          case 2:
            this.trackPopupInfo = {
              lng: tempFeature.get('lng'),
              lat: tempFeature.get('lat'),
              specModel: this.currentItem.specModel,
              serialNumber: this.currentItem.serialNumber,
              userName: this.currentItem.userName,
              logTimestamp: tempFeature.get('logTimestamp'),
            }
            popupContainer.style.display = 'block'
            //设置overlay的显示位置
            popup.setPosition([tempFeature.get('lng'), tempFeature.get('lat')])
            break
          case 3:
            // 点击室内地图展示对应组件
            this.indoorMapVisible = true
            break
        }
      })
    },
    formatPressure(value) {
      let res = (Number(value) / 10).toFixed(1)
      return res
    },
    closePopup() {
      // 把弹窗位置设置为undefined，并清空坐标数据
      popup.setPosition(undefined)
      document.getElementById('popup-closer').blur()
      // 清空轨迹泡泡数据
      this.trackPopupInfo = {}
      return false
    },
    // 关闭历史记录弹窗
    closeHistoryRecord() {
      this.showHistoryRecord = false
    },
    // 关闭jls轨迹弹窗
    closeJlsTrail() {
      this.JlsTrailVisible = false
    },
    // 弹窗关闭事件 jls和gk3的
    infoWindowClose() {
      this.infoWindowHeight = 200
      this.infoWindow.show = false
      this.trackPopupInfo = {}
    },
    infoWindowGkClose() {
      this.infoWindowHeight = 200
      this.infoWindow.gkShow = false
      this.closePopup()
    },
    infoWindowjlsClose() {
      this.infoWindowHeight = 200
      this.infoWindow.jlsShow = false
      this.closePopup()
    },
    // 点击历史记录弹窗 播放轨迹 按钮事件
    playTrail() {
      this.listTrack = this.trailData
      this.listTrackIndex = this.trailIndex
      this.trail = []
      console.log(mapOl, 'mapOl')
      setTimeout(() => {
        if (window.innerHeight < 400) {
          mapOl.getView().setZoom(14)
        } else {
          mapOl.getView().setZoom(17)
        }
        console.log(window.innerWidth + ',' + window.innerHeight, '宽度')
        this.showTrackController = true
        this.showIcons = true
      }, 1000)
    },
    // 点击jls轨迹弹窗 播放轨迹 按钮事件
    playJlsTrail(data, index) {
      this.showTrackController = true
      this.showIcons = true
      this.listTrack = this.jlstrailData
      this.listTrackIndex = this.jlstrailIndex
      this.currentItem = this.ExitjlsHelmetInfo
      this.trail = []
    },
    // 关闭播放轨迹窗口
    closeTrackController() {
      // 清空轨迹泡泡数据
      let mainBox = document.getElementsByClassName('mainContain')
      if (mainBox && mainBox[0]) {
        mainBox[0].style.zIndex = 99
      }

      this.trackPopupInfo = {}
      this.showTrackController = false
      this.$emit('update:showMap', false)
      if (this.currentItem) {
        store.commit('ExitJlsTrailIndex', 0)
        // 关闭 轨迹控制器显示历史弹窗 (根据specType判断是JLS还是二郎神的设备)
        if (this.currentItem.specType === 0) {
          store.commit('jlsTrackList', true)
        }
      }
    },
    // 轨迹开始绘制事件 - 清空弹窗
    drawTrackStart() {
      // 同时关闭设备详情弹窗
      this.infoWindowGkClose()
      this.infoWindowjlsClose()
      this.trackPopupInfo = {}
    },
    // 关闭轨迹录像播放，轨迹控制器正常使用
    trailVideo() {
      this.showTrackVideo = true
    },
    //开启轨迹视频
    openTrackVideo(val, showVideo, secondTime) {
      this.trailVideoData = val
      this.showVideo = showVideo
      this.videoSecond = secondTime
      this.showTrackVideo = false
    },
    // 切换地图类型
    switchMapType(type) {
      this.mapType = type
      // 切换地图类型 设置最大层级
      if (type === 'street') {
        switchMapType('street', mapOl)
        mapOl.getView().setMaxZoom(19)
      } else {
        switchMapType('satellite', mapOl)
        mapOl.getView().setMaxZoom(18)
      }
    },
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
@import '~@/style/popup-ol.styl'
.el-main
  padding 0!important
  height calc(100% - 30px);/*no*/
  overflow: hidden
  position: relative
  bg-image('~@/icon/re-new-header/bg.png')
  .mainMonitor
    height 100%
    margin 0 20px
    border-radius: 4px;
    position relative
    .maskbg
      height 250px
      width 100%
      position absolute
      bottom 0
      pointer-events: none;
      bg-image('~@/icon/new-command/whitebg.png')
    .mainContain
      position absolute
      top:0px;
      left: 0;
      right: 0;
      bottom: 0;
      //外层元素禁止点击事件
      pointer-events: none;
      background: #fff;
      z-index: 99
      height 100%
    .bgMainContain
      background: none;

    .map-switch
      position: absolute;
      background: white;
      z-index: 1;
      cursor: pointer;
      border-radius: 2px;
      overflow: hidden;
      left: 420px;
      top: 80px;
      div
        box-shadow: rgb(0 0 0 / 35%) 2px 2px 3px;
        border-width: 1px;
        border-style: solid;
        border-color: rgb(139, 164, 220);
        background: rgb(255, 255, 255);
        padding: 2px 6px;
        font-style: normal;
        font-variant: normal;
        font-stretch: normal;
        font-size: 12px;
        line-height: 1.3em;
        font-family: arial, sans-serif;
        text-align: center;
        white-space: nowrap;
        color: rgb(0, 0, 0);
        float left
        &.active
          box-shadow: rgb(0 0 0 / 35%) 2px 2px 3px;
          border-left: 1px solid rgb(139, 164, 220);
          border-top: 1px solid rgb(139, 164, 220);
          border-bottom: 1px solid rgb(139, 164, 220);
          background: rgb(142, 168, 224);
          padding: 2px 6px;
          font: bold 12px / 1.3em arial, sans-serif;
          text-align: center;
          white-space: nowrap;
          color: rgb(255, 255, 255);
</style>
